import { CommonModule } from '@angular/common';
import { NgModule ,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {FooterComponent} from './components/speaker/footer/footer/footer.component';
import{HeaderComponent} from './components/speaker/header/header/header.component';
import { ReactiveFormsModule } from '@angular/forms';
import {  MatTabsModule, MatCardModule, MatDialogModule,
    MatDatepickerModule, MatFormFieldModule, MatInputModule,
    MatRadioModule, MatSelectModule,
   } from '@angular/material';
   import{AppMaterialModule} from './material.module';
   import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import{FullCalendarModule} from'ng-fullcalendar';
import {SlideshowModule} from 'ng-simple-slideshow';
import{UnavailablecalenderComponent} from './components/shared/unavailablecalender/unavailablecalender.component';
import {EventsComponent} from './components/speaker/event/events/events.component';
import{MyTrainingComponent} from './components/shared/training/myTraining/myTraining.component';
import {ViewCalenderComponent} from './components/shared/view-calender/view-calender.component';
@NgModule({
 imports:[ReactiveFormsModule, FullCalendarModule,
         MatTabsModule, MatCardModule, MatDialogModule,
         MatDatepickerModule, MatFormFieldModule, MatInputModule,
         MatRadioModule, MatSelectModule,
         SlideshowModule,
         AppMaterialModule,
        CommonModule , FormsModule],
 declarations: [ViewCalenderComponent,UnavailablecalenderComponent,MyTrainingComponent,EventsComponent,HeaderComponent,FooterComponent],
 exports:      [ViewCalenderComponent,
                FullCalendarModule,
                SlideshowModule,
                MatProgressSpinnerModule,
                UnavailablecalenderComponent,
                AppMaterialModule,
               MatTabsModule, MatCardModule, MatDialogModule,
               MatDatepickerModule, MatFormFieldModule, MatInputModule,
               MatRadioModule, MatSelectModule, 
               MyTrainingComponent,EventsComponent,ReactiveFormsModule,HeaderComponent,FooterComponent,FormsModule,CommonModule],
 schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class SharedModule { }